import React from 'react';

export default function AboutSection() {
  return (
    <section id="about" className="section">
      <div className="section-content about-content">
        <h2 className="section-title">About Me</h2>

        {/* Introduction */}
        <div className="about-intro">
          <p className="about-greeting">Hello! I'm <span className="highlight">Jhon Jeremie Escorial Baita</span></p>
          <p className="about-description">
            A passionate and driven <strong>Computer Engineering student</strong> who thrives at
            the intersection of hardware and software. I'm dedicated to building innovative
            solutions that make a real-world impact, combining technical excellence with creative problem-solving.
          </p>
        </div>

        {/* Info Cards Slider */}
        <div className="about-slider-wrapper" style={{ width: '100%', padding: '1rem 0' }}>
          <div
            className="about-slider-track"
            style={{
              display: 'flex',
              gap: '1.5rem',
              overflowX: 'auto',
              scrollSnapType: 'x mandatory',
              scrollBehavior: 'smooth',
              paddingBottom: '1rem',
              /* Add a custom class for hiding scrollbar if preferred, or rely on existing */
            }}
          >

            {/* Why Computer Engineering */}
            <div className="about-card" style={{ flex: '0 0 auto', width: 'min(100%, 420px)', scrollSnapAlign: 'center' }}>
              <div className="about-card-icon">
                <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <rect x="2" y="3" width="20" height="14" rx="2" ry="2" />
                  <line x1="8" y1="21" x2="16" y2="21" />
                  <line x1="12" y1="17" x2="12" y2="21" />
                </svg>
              </div>
              <h3>Why Computer Engineering?</h3>
              <p>
                I've always been fascinated by how technology shapes the world around us. Choosing
                Computer Engineering allows me to explore both the hardware foundations and
                the software innovations that drive modern technology. The blend of circuits,
                systems, and code gives me a holistic view of how things work — from the processor
                level all the way up to full-stack applications.
              </p>
            </div>

            {/* Field of Interest */}
            <div className="about-card" style={{ flex: '0 0 auto', width: 'min(100%, 420px)', scrollSnapAlign: 'center' }}>
              <div className="about-card-icon">
                <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <polyline points="16 18 22 12 16 6" />
                  <polyline points="8 6 2 12 8 18" />
                  <line x1="14" y1="4" x2="10" y2="20" />
                </svg>
              </div>
              <h3>What Interests Me Most</h3>
              <p>
                I'm deeply passionate about <strong>software development</strong> and <strong>web technologies</strong>.
                Building clean, modern web applications with frameworks like React excites me the most.
                I also have a growing interest in embedded systems, IoT, and how software integrates
                with hardware to create smart, connected solutions.
              </p>
            </div>

            {/* Career Goals */}
            <div className="about-card" style={{ flex: '0 0 auto', width: 'min(100%, 420px)', scrollSnapAlign: 'center' }}>
              <div className="about-card-icon">
                <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
                  <polyline points="22 4 12 14.01 9 11.01" />
                </svg>
              </div>
              <h3>Career Goals & Aspirations</h3>
              <p>
                My goal is to become a <strong>professional software engineer</strong> who builds scalable,
                user-centric applications. I aspire to work in a dynamic tech environment where I
                can contribute to meaningful projects, grow as a full-stack developer, and eventually
                lead engineering teams that create products that positively impact people's lives.
              </p>
            </div>

            {/* Personal Strengths */}
            <div className="about-card" style={{ flex: '0 0 auto', width: 'min(100%, 420px)', scrollSnapAlign: 'center' }}>
              <div className="about-card-icon">
                <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                </svg>
              </div>
              <h3>Personal Strengths</h3>
              <p>
                I bring <strong>adaptability</strong>, <strong>resilience</strong>, and a
                strong <strong>work ethic</strong> to every challenge. I'm a fast learner who
                embraces new technologies with enthusiasm, a detail-oriented problem solver,
                and a collaborative team player. My curiosity drives me to constantly improve
                and push beyond the limits of what I know.
              </p>
            </div>

          </div>
        </div>

        {/* Personal Motto / Quote */}
        <div className="about-quote">
          <div className="quote-mark">"</div>
          <blockquote>
            I believe that technology, when combined with passion and purpose, has the power
            to transform ideas into reality and create a better future for everyone.
          </blockquote>
        </div>

      </div>
    </section>
  );
}
